import { TypedSopNode } from "./_Base";
import { ReflectorSopOperation } from "../../operations/sop/Reflector";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
const DEFAULT = ReflectorSopOperation.DEFAULT_PARAMS;
class ReflectorSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.direction = ParamConfig.VECTOR3(DEFAULT.direction.toArray());
    this.active = ParamConfig.BOOLEAN(DEFAULT.active);
    this.clipBias = ParamConfig.FLOAT(DEFAULT.clipBias);
    this.color = ParamConfig.COLOR(DEFAULT.color.toArray());
    this.opacity = ParamConfig.FLOAT(DEFAULT.opacity);
    this.pixelRatio = ParamConfig.INTEGER(DEFAULT.pixelRatio, {
      range: [1, 4],
      rangeLocked: [true, false]
    });
    this.multisamples = ParamConfig.INTEGER(DEFAULT.multisamples, {
      range: [0, 4],
      rangeLocked: [true, false]
    });
    this.tblur = ParamConfig.BOOLEAN(DEFAULT.tblur);
    this.blur = ParamConfig.FLOAT(DEFAULT.blur, {
      visibleIf: { tblur: 1 }
    });
    this.verticalBlurMult = ParamConfig.FLOAT(DEFAULT.verticalBlurMult, {
      visibleIf: { tblur: 1 }
    });
    this.tblur2 = ParamConfig.BOOLEAN(DEFAULT.tblur2, {
      visibleIf: { tblur: 1 }
    });
    this.blur2 = ParamConfig.FLOAT(DEFAULT.blur2, {
      visibleIf: { tblur: 1, tblur2: 1 }
    });
    this.verticalBlur2Mult = ParamConfig.FLOAT(DEFAULT.verticalBlur2Mult, {
      visibleIf: { tblur: 1, tblur2: 1 }
    });
  }
}
const ParamsConfig = new ReflectorSopParamsConfig();
export class ReflectorSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "reflector";
  }
  static displayedInputNames() {
    return ["geometry to create a reflector from"];
  }
  initializeNode() {
    this.io.inputs.setCount(0, 1);
    this.io.inputs.initInputsClonedState(ReflectorSopOperation.INPUT_CLONED_STATE);
  }
  async cook(input_contents) {
    this._operation = this._operation || new ReflectorSopOperation(this._scene, this.states, this);
    const core_group = await this._operation.cook(input_contents, this.pv);
    this.setCoreGroup(core_group);
  }
}
